import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import '../assets/css/skeletonTable.css'

const TableSkeleton = ({
    columns = 6,
    rowHeight = 72, // match .student-table row height
    showHeader = true,
}) => {

       const rows = Math.floor((window.innerHeight - 200) / rowHeight); // 200 = approx header/padding offset
    return (
        <SkeletonTheme
            baseColor="#e0e0e0"
            highlightColor="#f5f5f5"
            duration={1.2}
        >  <div style={{ overflow: "hidden", width: "100%",height:'100%' }}>
            <table className="student-table customise-table" style={{height:'100%'}}>
                {showHeader && (
                    <thead>
                        <tr>
                            {Array(columns)
                                .fill(0)
                                .map((_, colIndex) => (
                                    <th key={colIndex}>
                                        <Skeleton height={20} width="80%" />
                                    </th>
                                ))}
                        </tr>
                    </thead>
                )}

                <tbody>
                    {Array(rows)
                        .fill(0)
                        .map((_, rowIndex) => (
                            <tr
                                key={rowIndex}
                                className={rowIndex % 2 === 0 ? "" : "odd-row"}
                                style={{ height: `${rowHeight}px` }}
                            >
                                {Array(columns)
                                    .fill(0)
                                    .map((_, colIndex) => (
                                        <td key={colIndex}>
                                            <Skeleton height={16} width="90%" />
                                        </td>
                                    ))}
                            </tr>
                        ))}
                </tbody>
            </table>
            </div>
        </SkeletonTheme>
    );
};

export default TableSkeleton;
